import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import api from 'services/api';
import { Actions } from 'services/PlayerService';

import useInterval from 'utils/hooks/useInterval';
import { checkDuration, frameToTCString } from 'utils/timecode';

import {
  insertRequest,
  playbetweenRequest,
  pauseRequest,
  setPositionRequest,
  stepRequest,
  setMarkRequest,
  getPositionRequest,
  playRequest,
  playerClear,
} from 'store/modules/player/actions';
import { show } from 'store/modules/dialog/actions';

import Card from 'components/Card';
import Tabs, { Tab } from 'components/Tabs';
import PendentesAvaliacaoLoader from 'components/ContentLoader/PendentesAvaliacaoLoader';
import Button from 'components/Button';
import Slider from 'components/Slider';
import Tooltip from 'components/Tooltip';
import Spinner from 'components/Spinner';
import Flag from 'components/Flag';
import Pagination from 'components/Pagination';
import PlayerLoader from 'components/ContentLoader/PlayerLoader';
import NotFound from 'components/NotFound';
import PlayerBaixa from 'components/PlayerBaixa';
import SelectCreatable from 'components/SelectCreatable';

import {
  Container,
  RightContent,
  LeftContent,
  Table,
  CardHeader,
  TdFlag,
  Tbody,
  Tr,
  CardContent,
  Controls,
  SliderContent,
  Infos,
  CardActions,
  MidiaInfo,
  Image,
  ThumbnailContainer,
  Scroll,
  DuracaoSelecionada,
  ModalAvaliacao,
} from './styles';
import { Td } from 'styles/global';

import {
  FiPlay,
  FiPause,
  FiSkipBack,
  FiSkipForward,
  FiChevronsDown,
  FiChevronsUp,
  FiChevronDown,
  FiChevronUp,
  FiInfo,
  FiRotateCcw,
} from 'react-icons/fi';
import { MdCompareArrows } from 'react-icons/md';
import PendenteAvaliacao from 'assets/PendenteAvaliacao.svg';
import notfound from 'assets/semimagem.png';
import { Form } from '@unform/web';
import { Avaliacaoeng, Categoria, Role } from 'utils/variables';
import midiainfo from 'utils/midiainfo';
import AppError from 'utils/AppError';
import { Cliente, Emissora, Midia, Produtora } from 'pages/@types';
import { FormHandles } from '@unform/core';
import getValidationErrors from 'services/getValidationErros';
import { useModal } from 'hooks/modal';
import TextArea from 'components/TextArea';
import { usePermit } from 'utils/hooks/usePermit';

interface MateriaisPendentes {
  pages: number;
  page: number;
  total: number;
  docs: MaterialPendente[];
}

interface MaterialPendente {
  id: number;
  duracao: number;
  retranca?: string;
  categoria?: string;
  titulo?: string;
  midiaindisponivel?: boolean;
  globoexpress?: boolean;
  codmaterial?: number;
  cliente: Cliente;
  tipo:
    | 'chamada'
    | 'vinheta'
    | 'promocional'
    | 'chpatrocinada'
    | 'apoio'
    | 'campanha'
    | 'afinacao'
    | 'programete'
    | 'videopatrocinado'
    | 'campanhapatrocinada';
  midia: Midia;
}

interface ProdutoraOption {
  value: number;
  label: string;
}
// configuração do validator
const schema = Yup.object().shape({
  produtora: Yup.string().required('Campo Obrigatório'),
});
const schemaAvaliacaoEng = Yup.object().shape({
  obsreprova: Yup.string().required('Preencha o motivo'),
});

export default function Player() {
  const [comerciaisPendentes, setComerciaisPendentes] = useState<
    MateriaisPendentes
  >({
    page: 0,
    pages: 0,
    total: 0,
    docs: [],
  });
  const [chamadasPendentes, setChamadasPendentes] = useState<
    MateriaisPendentes
  >({
    page: 0,
    pages: 0,
    total: 0,
    docs: [],
  });
  const [midiasPendentes, setMidiasPendentes] = useState<MateriaisPendentes>({
    page: 0,
    pages: 0,
    total: 0,
    docs: [],
  });
  const [produtoras, setProdutoras] = useState<ProdutoraOption[]>([]);
  const [pageComercial, setPageComercial] = useState(1);
  const [pageChamada, setPageChamada] = useState(1);
  const [pageMidia, setPageMidia] = useState(1);
  const [activeTabIndex, setActiveTabIndex] = useState(3);
  const [loadingComerciais, setLoadingComerciais] = useState(false);
  const [initialDataProdutora, setInitialDataProdutora] = useState({});
  const [loadingChamadas, setLoadingChamadas] = useState(false);
  const [loadingMidias, setLoadingMidias] = useState(false);
  const [hasProdutora, setHasProdutora] = useState(true);
  const { showModal, hideModal } = useModal();
  const status = useRef('');
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });

  // Essa referencia é usada no formulario da avaliacao
  const formRef = useRef<FormHandles>(null);
  const formRefAvaliacaoEng = useRef<FormHandles>(null);

  // Criada ref para que seja possível detectar mudança de emissora no selectEmissora
  // Caso seja alterado a emissora, volta para a page 1
  const { emissora } = useSelector((state: any) => state.usuario);

  const hasLoadPlayer = usePermit([Role.ENG], []);

  // referencia
  const lastEmissora = useRef(emissora ? emissora.value : null);

  const dispatch = useDispatch();
  const {
    loading: loadingPlayer,
    playerADX,
    selected,
    destinos,
    isPlaying,
    isPlayingBetween,
  } = useSelector((state: any) => state.player);

  const keyMap = {
    MOVE_LEFT: 'left',
    MOVE_RIGHT: 'right',
    PLAY_PAUSE: 'SPACE_BAR',
    GOTO_IN: [',', '<'],
    GOTO_OUT: ['.', '>'],
    MARK_IN: ['i', 'I'],
    MARK_OUT: ['o', 'O'],
  };

  async function handleSelect(
    pend: MaterialPendente,
    type: 'midia' | 'chamada' | 'comercial',
  ) {
    try {
      const { data } = await api.get(`/playermidias/${pend.midia.id}`);
      const pendente = data.pendente;

      const isComercial =
        pendente.categoria === Categoria.COMERCIAL &&
        pendente.cliente &&
        !pendente.cliente.politico_at;

      if (isComercial) {
        if (pendente.produtora)
          // Se o comercial tiver a produtora no banco, pré-preenche o select de produtora
          setInitialDataProdutora({
            produtora: {
              value: pendente.produtora.id,
              label: pendente.produtora.nome,
            },
          });
        // Caso contrário, pré-preenche o select com SEM PRODUTORA
        else
          setInitialDataProdutora({
            produtora: { value: 806, label: 'SEM PRODUTORA' },
          });
        setHasProdutora(false);
      } else setHasProdutora(true);

      dispatch(
        insertRequest({
          ...data,
          pendente: {
            ...pendente,
            [`${type}_id`]: pend.id,
            duracao: pend.duracao, // TODO: revisar
            titulo: pend.titulo || pend.retranca || pend.midia.filename,
            type,
          },
        }),
      );
    } catch (err) {
      const message =
        err instanceof Error ? err.message : (err as AppError).message;
      toast.error(message);
    }
  }

  const handleLoad8Ch = useCallback(async (pend: MaterialPendente) => {
    if (pend.midia.id) {
      const response = await api.get(`/playermidias/${pend.midia.id}`);
      if (
        response &&
        response.data &&
        response.data.pendente &&
        response.data.pendente.midia
      ) {
        dispatch(
          insertRequest({
            ...response.data,
            pendente: {
              ...response.data.pendente,
              midia: {
                ...response.data.pendente.midia,
                filepath_normalized: response.data.pendente.midia.filepath_normalized.replace(
                  '-16CH',
                  '-8CH',
                ),
              },
              comercial_id: pend.id,
              duracao: pend.duracao, // CORRIGIR!!!!
              titulo: `8CH-${pend.titulo}`,
              type: 'comercial',
            },
          }),
        );
      } else
        toast.error(`Falha ao carregar a mídia original de ${pend.titulo}`);
    } else toast.error(`Falha ao carregar a mídia original de ${pend.titulo}`);
  }, []);

  const handleMidiaInfoDialog = useCallback(
    (processed: boolean) => {
      if (selected && selected.midia && selected.midia.midiainfo) {
        if (
          processed &&
          selected.midia.midiainfo &&
          selected.midia.statuspreavaliacao
        ) {
          const options = midiainfo(
            selected.midia.statuspreavaliacao,
            selected.midia.midiainfo,
          );
          dispatch(show(options));
        } else if (
          selected.midia.midiainfo8ch &&
          selected.midia.statuspreavaliacao8ch
        ) {
          const options = midiainfo(
            selected.midia.statuspreavaliacao8ch,
            selected.midia.midiainfo8ch,
          );
          dispatch(show(options));
        }
      }
    },
    [dispatch, selected],
  );

  function handleThumbnailDialog(img: string) {
    const options = {
      contentHTML: `<h3>CLAQUETE</h3><img src=${img} alt="thumbnail" style="max-width:100%;
      max-height:100%;"/>`,
      showCancelButton: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'FECHAR',
    };
    dispatch(show(options));
  }

  function handleDialog() {
    const contentHTML =
      `<div> <ul>` +
      '<li>' +
      `PLAYER ID: <strong>${playerADX.id}</strong>` +
      '</li>' +
      '<li>' +
      `MIDIA ID: <strong>${selected.midia.id}</strong>` +
      '</li>' +
      '<li>' +
      `NOME: <strong>${playerADX.nome}</strong>` +
      '</li>' +
      '<li>' +
      `IP: <strong>${playerADX.ip}</strong>` +
      '</li>' +
      '<li>' +
      `PORTA: <strong>${playerADX.porta}</strong>` +
      '</li>' +
      '<li>' +
      `MARKIN TIMECODE: <strong>${playerADX.markin_tc}</strong>` +
      '</li>' +
      '<li>' +
      `MARKIN FRAME: <strong>${playerADX.markin_frame}</strong>` +
      '</li>' +
      '<li>' +
      `DURATION FRAME: <strong>${playerADX.duration}</strong>` +
      '</li>' +
      '<li>' +
      `MARKOUT FRAME: <strong>${playerADX.markout_frame}</strong>` +
      '</li>' +
      '<li>' +
      `LAST FRAME:<strong>${playerADX.last_frame}</strong>` +
      '</li>' +
      '</ul></div> ';

    const options = {
      type: 'info',
      contentHTML,
      confirmButtonText: 'FECHAR',
      showCancelButton: false,
      showConfirmButton: true,
    };
    dispatch(show(options));
  }

  const handleSubmitAvalicaoEng = useCallback(
    async data => {
      if (formRefAvaliacaoEng.current && playerADX) {
        try {
          formRefAvaliacaoEng.current.setErrors({});
          if (
            status.current === Avaliacaoeng.REPROVADO ||
            status.current === Avaliacaoeng.RESSALVA
          ) {
            await schemaAvaliacaoEng.validate(data, { abortEarly: false });
          }

          const response = await api.put(`/midias/${selected.midia.id}`, {
            avaliacaoeng:
              status.current === 'reprovado_patrocinio'
                ? Avaliacaoeng.REPROVADO
                : status.current,
            ...(data.obsreprova && { obseng: data.obsreprova }),
            ...(playerADX.markin_tc && { markin: playerADX.markin_tc }),
            ...(playerADX.markout_tc && { markout: playerADX.markout_tc }),
            ...(playerADX.duration && { duration: playerADX.duration }),
            ...(status.current === 'reprovado_patrocinio' && {
              categoria: Categoria.PATROCINIO,
            }),
          });
          if (response?.data) {
            toast.success('Mídia avaliada com sucesso');
          } else toast.error('Falha de comunicação com o sistema');

          if (selected.categoria === Categoria.COMERCIAL)
            setComerciaisPendentes(prevState => ({
              ...prevState,
              docs: prevState.docs.filter(p => p.midia.id !== selected.id),
              total: prevState.total - 1,
            }));
          else if (selected.categoria === Categoria.CHAMADA)
            setChamadasPendentes(prevState => ({
              ...prevState,
              docs: prevState.docs.filter(p => p.midia.id !== selected.id),
              total: prevState.total - 1,
            }));
          else
            setMidiasPendentes(prevState => ({
              ...prevState,
              docs: prevState.docs.filter(p => p.midia.id !== selected.id),
              total: prevState.total - 1,
            }));

          dispatch(playerClear());
          hideModal();
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            formRefAvaliacaoEng.current.setErrors(errors);
            return;
          }
          if (error instanceof AppError) toast.error(error.message);
          else if (error instanceof Error) toast.error(error.message);
          else {
            const appError = error as AppError;
            if (appError.message) toast.error(appError.message);
            else toast.error('Erro inesperado');
          }
        }
      }
    },
    [dispatch, hideModal, playerADX, selected],
  );

  const renderAvaliacaoEng = useCallback(
    (msg, titulo) => {
      return (
        <Form ref={formRefAvaliacaoEng} onSubmit={handleSubmitAvalicaoEng}>
          <ModalAvaliacao>
            <div>
              <h3>{msg}</h3>
              <h3>{titulo}</h3>
            </div>
            {status.current !== Avaliacaoeng.APROVADO && (
              <TextArea
                placeholder="Observação"
                name="obsreprova"
                height="9rem"
                disable={false}
                max={800}
                errorField=""
                icon=""
              />
            )}
            <Button type="submit" color="primary">
              CONFIRMAR
            </Button>
          </ModalAvaliacao>
        </Form>
      );
    },
    [handleSubmitAvalicaoEng],
  );

  const handleAvaliacaoEng = useCallback(
    (selectedStatus, titulo) => {
      status.current = selectedStatus;
      let msg;
      switch (status.current) {
        case Avaliacaoeng.APROVADO:
          msg = 'Confirmar APROVAÇÃO de:';
          break;
        case Avaliacaoeng.RESSALVA:
          msg = 'Confirmar APROVAÇÃO COM RESSALVA de:';
          break;
        default:
          msg = 'Confirmar REPROVA de:';
          break;
      }
      if (formRefAvaliacaoEng.current) formRefAvaliacaoEng.current.reset();
      showModal({
        title: 'AVALIAÇÃO',
        component: renderAvaliacaoEng(msg, titulo),
        width: '30vw',
      });
    },
    [renderAvaliacaoEng, showModal],
  );

  function handlePlayer(command: string, position?: number) {
    switch (command) {
      case Actions.PLAY:
        dispatch(
          playRequest({
            idPlayer: playerADX.id,
            command,
          }),
        );
        break;
      case Actions.PLAYBETWEEN:
        dispatch(playbetweenRequest(playerADX));
        break;
      case Actions.PAUSE:
        dispatch(pauseRequest(playerADX));
        break;
      case Actions.SETFRAGMENT:
        dispatch(
          setPositionRequest({
            idPlayer: playerADX.id,
            position,
            command,
          }),
        );
        break;
      case Actions.GOTOMARKIN:
        dispatch(
          setPositionRequest({
            idPlayer: playerADX.id,
            position: playerADX.markin_frame,
            command,
          }),
        );
        break;
      case Actions.GOTOMARKOUT:
        dispatch(
          setPositionRequest({
            idPlayer: playerADX.id,
            position: playerADX.markout_frame,
            command,
          }),
        );
        break;
      case Actions.STEPBACK:
        dispatch(
          stepRequest({
            idPlayer: playerADX.id,
            command,
          }),
        );
        break;
      case Actions.STEPFORWARD:
        dispatch(
          stepRequest({
            idPlayer: playerADX.id,
            command,
          }),
        );
        break;
      case Actions.MARKIN:
        dispatch(
          setMarkRequest({
            idPlayer: playerADX.id,
            command,
          }),
        );
        try {
          if (selected.duracao) {
            checkDuration(
              selected.duracao,
              playerADX.markout_frame - playerADX.current,
            );
          }
        } catch (error) {
          if (error instanceof Error) {
            toast.warn(error.message);
          }
        }

        break;
      case Actions.MARKOUT:
        dispatch(
          setMarkRequest({
            idPlayer: playerADX.id,
            command,
          }),
        );
        try {
          if (selected.duracao) {
            checkDuration(
              selected.duracao,
              playerADX.current - playerADX.markin_frame,
            );
          }
        } catch (error) {
          if (error instanceof Error) {
            toast.warn(error.message);
          }
        }
        break;
      case Actions.GETPOSITION:
        dispatch(
          getPositionRequest({
            idPlayer: playerADX.id,
            command,
          }),
        );
        break;
      default:
        break;
    }
  }

  const handlers = {
    MOVE_LEFT: () => handlePlayer(Actions.STEPBACK),
    MOVE_RIGHT: () => handlePlayer(Actions.STEPFORWARD),
    GOTO_IN: () => handlePlayer(Actions.GOTOMARKIN),
    GOTO_OUT: () => handlePlayer(Actions.GOTOMARKOUT),
    MARK_IN: () => handlePlayer(Actions.MARKIN),
    MARK_OUT: () => handlePlayer(Actions.MARKOUT),
    PLAY_PAUSE: (event?: KeyboardEvent) => {
      if (event) event.preventDefault();
      isPlaying || isPlayingBetween
        ? handlePlayer(Actions.PAUSE)
        : handlePlayer(Actions.PLAY);
    },
  };

  useInterval(() => {
    // Your custom logic here
    if (isPlaying || isPlayingBetween) {
      handlePlayer(Actions.GETPOSITION);
    }
  }, 150);

  const duracaoSelecionada = useMemo(() => {
    if (
      playerADX &&
      playerADX.markout_frame &&
      (playerADX.markin_frame || playerADX.markin_frame === 0)
    ) {
      return frameToTCString(
        playerADX.markout_frame - playerADX.markin_frame,
      ).replace('00:', '');
    }
    return '00:00;00';
  }, [playerADX]);

  const enablePreview = useCallback(
    midia => midia.statusbaixa !== 'processado',
    [],
  );

  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  const handlePlayerPreview = useCallback(
    previewurl => {
      if (previewurl) {
        setPlayer({
          open: !player.open,
          midia_url: previewurl,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );

  /**
   * Essa função faz o submit da produtora
   **/

  const handleSubmit = useCallback(
    async data => {
      try {
        if (formRef.current) formRef.current.setErrors({});
        await schema.validate({ ...data }, { abortEarly: false });

        const formData = Object.assign({ produtora: data.produtora });

        await api.put(`/comerciaists/${selected.comercial_id}`, formData);
        toast.success('Produtora vinculada');
        setHasProdutora(true);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          if (formRef.current) formRef.current.setErrors(errors);
        }

        // const validationErrors = {};
        // if (err instanceof Yup.ValidationError) {
        //   err.inner.forEach(error => {
        //     validationErrors[error.path] = error.message;
        //   });
        //   if (formRef.current) formRef.current.setErrors(validationErrors);
        // }
      }
    },
    [selected],
  );

  const minDuration = useCallback(() => {
    return playerADX && playerADX.markout_frame && playerADX.markin_frame
      ? playerADX.markout_frame - playerADX.markin_frame > 148
      : true;
  }, [playerADX]);

  const foraMargem = useCallback(() => {
    if (
      playerADX &&
      playerADX.markout_frame &&
      playerADX.markin_frame &&
      selected &&
      selected.duracao
    )
      try {
        checkDuration(
          selected.duracao,
          playerADX.markout_frame - playerADX.markin_frame,
        );
        return false;
      } catch (error) {
        return true;
      }
  }, [playerADX, selected]);

  // carrega comerciais
  useEffect(() => {
    const controller = new AbortController();
    async function loadComerciaisPendentes() {
      setLoadingComerciais(true);
      try {
        const response = await api.get(`/comerciaists/pendentes`, {
          signal: controller.signal,
          params: {
            page: lastEmissora.current === emissora.value ? pageComercial : 1,
            emissora_id: emissora.value,
          },
        });
        if (response && response.data) {
          setComerciaisPendentes({
            ...response.data,
            docs: response.data.comerciais,
            page: lastEmissora.current === emissora.value ? pageComercial : 1,
          });
        }
        lastEmissora.current = emissora ? emissora.value : null;
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
        }
      }
      setLoadingComerciais(false);
    }
    if (hasLoadPlayer) loadComerciaisPendentes();
    return () => {
      controller.abort();
    };
  }, [emissora, pageComercial]);

  useEffect(() => {
    const controller = new AbortController();
    async function loadProdutoras() {
      const responseProdutoras = await api.get<Produtora[]>('/produtoras');

      if (responseProdutoras?.data) {
        // Caso contrário, limpa a produtora
        setProdutoras(
          responseProdutoras.data.map(({ id, nome }) => ({
            value: id,
            label: nome,
          })),
        );
      }
      try {
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
        }
      }
    }
    if (hasLoadPlayer) loadProdutoras();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    async function loadPendentesChamadas() {
      setLoadingChamadas(true);
      try {
        const response = await api.get(`/pendentes/chamadas`, {
          signal: controller.signal,
          params: { page: pageChamada },
        });
        if (response && response.data) {
          setChamadasPendentes({ ...response.data, page: pageChamada });
        }
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
        }
      }
      setLoadingChamadas(false);
    }
    if (hasLoadPlayer) loadPendentesChamadas();
    return () => {
      controller.abort();
    };
  }, [pageChamada]);

  useEffect(() => {
    const controller = new AbortController();
    async function loadPendentesMidias() {
      setLoadingMidias(true);
      try {
        const response = await api.get(`/pendentes/midias`, {
          signal: controller.signal,
          params: { page: pageMidia, emissora_id: emissora.value },
        });
        if (response && response.data) {
          setMidiasPendentes({ ...response.data, page: pageMidia });
        }
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
        }
      }
      setLoadingMidias(false);
    }
    loadPendentesMidias();
    return () => {
      controller.abort();
    };
  }, [emissora.value, pageMidia]);

  return (
    <Container
      keyMap={keyMap}
      handlers={playerADX ? handlers : {}}
      allowChanges
      component="div"
      root
    >
      <LeftContent>
        <Tabs>
          <Tab
            id={1}
            checked={activeTabIndex === 1}
            onChange={() => setActiveTabIndex(1)}
            title="OUTRAS MIDIAS"
            count={midiasPendentes.total}
          >
            <header>
              <h4>OUTRAS MIDIAS</h4>
            </header>
            {loadingMidias ? (
              <PendentesAvaliacaoLoader />
            ) : midiasPendentes.docs.length === 0 ? (
              <NotFound img={PendenteAvaliacao} title="">
                Nenhuma MÍDIA AVULSA pendente de avaliação
              </NotFound>
            ) : (
              <>
                <Pagination
                  total={midiasPendentes.pages}
                  activePage={midiasPendentes.page}
                  onClick={page => setPageMidia(page)}
                />
                <Scroll height="calc(100vh - 220px)">
                  <Table>
                    <thead>
                      <tr>
                        <th style={{ width: '5rem' }}>ID</th>
                        <th>RETRANCA</th>
                        <th style={{ width: '11rem' }}>TIPO</th>
                      </tr>
                    </thead>
                    <Tbody>
                      {!!midiasPendentes.docs &&
                        midiasPendentes.docs.map(p => (
                          <Tr
                            key={p.id}
                            onClick={() => handleSelect(p, 'midia')}
                            rowselected={!!(selected && p.id === selected.id)}
                          >
                            <Td>{`CH${p.midia.id}`}</Td>
                            <Td>{p.midia.filename}</Td>
                            <Td>
                              {' '}
                              <Flag
                                type={p.midia.categoria}
                                name={p.midia.categoria}
                              />
                            </Td>
                          </Tr>
                        ))}
                    </Tbody>
                  </Table>
                </Scroll>
              </>
            )}
          </Tab>
          {emissora.value === 1 && (
            <Tab
              id={2}
              checked={activeTabIndex === 2}
              onChange={() => setActiveTabIndex(2)}
              title="CHAMADAS"
              count={chamadasPendentes.total}
            >
              <header>
                <h4>CHAMADAS</h4>
              </header>
              {chamadasPendentes.docs.length > 0 && !loadingChamadas && (
                <>
                  <Pagination
                    total={chamadasPendentes.pages}
                    activePage={chamadasPendentes.page}
                    onClick={page => setPageChamada(page)}
                  />
                  <Scroll height="calc(100vh - 220px)">
                    <Table>
                      <thead>
                        <tr>
                          <th style={{ width: '5rem' }}>CM</th>
                          <th>RETRANCA</th>
                          <th style={{ width: '11rem' }}>TIPO</th>
                        </tr>
                      </thead>

                      <Tbody>
                        {!!chamadasPendentes.docs &&
                          chamadasPendentes.docs.map((p, index) => (
                            <Tr
                              key={p.id}
                              onClick={() => handleSelect(p, 'chamada')}
                              isIndisponivel={!!p.midiaindisponivel}
                              rowselected={
                                !!(selected && p.midia.id === selected.midia.id)
                              }
                            >
                              <Td>{p.codmaterial ? p.codmaterial : `-`}</Td>
                              <Td>{p.retranca}</Td>
                              <Td>
                                {' '}
                                <Flag type={p.tipo} name={p.tipo} />
                              </Td>
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </Scroll>
                </>
              )}
              {loadingChamadas && <PendentesAvaliacaoLoader />}
              {!loadingChamadas &&
                chamadasPendentes &&
                chamadasPendentes.docs.length === 0 && (
                  <NotFound title="" img={PendenteAvaliacao}>
                    Nenhuma CHAMADA pendente de avaliação
                  </NotFound>
                )}
            </Tab>
          )}
          <Tab
            id={3}
            checked={activeTabIndex === 3}
            onChange={() => setActiveTabIndex(3)}
            title="COMERCIAIS"
            count={comerciaisPendentes.total}
          >
            <header>
              <h4>COMERCIAIS</h4>
            </header>
            {comerciaisPendentes.docs.length > 0 && !loadingComerciais && (
              <>
                <Pagination
                  total={comerciaisPendentes.pages}
                  activePage={comerciaisPendentes.page}
                  onClick={page => setPageComercial(page)}
                />
                <Scroll height="calc(100vh - 220px)">
                  <Table>
                    <thead>
                      <tr>
                        <th />
                        <th style={{ width: '5rem' }}>CM</th>
                        <th>TITULO</th>
                        <th />
                        {/* <th>CLIENTE</th> */}
                      </tr>
                    </thead>

                    <Tbody>
                      {!!comerciaisPendentes &&
                        comerciaisPendentes.docs.map((p, index) => (
                          <Tr
                            key={p.id}
                            onClick={() => handleSelect(p, 'comercial')}
                            $isGe={!!p.globoexpress}
                            isIndisponivel={!!p.midiaindisponivel}
                            rowselected={
                              !!(selected && p.midia.id === selected.midia.id)
                            }
                          >
                            <TdFlag
                              $isGe={!!p.globoexpress}
                              isIndisponivel={!!p.midiaindisponivel}
                            >
                              <div id={`tdFlag_id${index}`} />
                              {(p.globoexpress || p.midiaindisponivel) && (
                                <Tooltip
                                  target={`tdFlag_id${index}`}
                                  position="right"
                                >
                                  {p.globoexpress && !p.midiaindisponivel ? (
                                    <p>
                                      <strong>PRIORITÁRIO:</strong> GLOBO
                                      EXPRESS
                                    </p>
                                  ) : !p.globoexpress && p.midiaindisponivel ? (
                                    <p>
                                      <strong>ERRO:</strong> MÍDIA INDISPONÍVEL
                                    </p>
                                  ) : p.globoexpress && p.midiaindisponivel ? (
                                    <>
                                      <p>
                                        <strong>PRIORITÁRIO:</strong> GLOBO
                                        EXPRESS
                                      </p>{' '}
                                      <p>
                                        <strong>ERRO:</strong> MÍDIA
                                        INDISPONÍVEL
                                      </p>
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </Tooltip>
                              )}
                            </TdFlag>
                            <td>{p.codmaterial}</td>
                            <td>
                              {p.titulo}{' '}
                              <strong>({p.cliente.mnemonico})</strong>
                            </td>
                            {selected?.id === p.midia.id ? (
                              <td>
                                <Button
                                  id="load8ch"
                                  fill
                                  color="font"
                                  round
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleLoad8Ch(p);
                                  }}
                                >
                                  <FiRotateCcw />
                                </Button>
                                <Tooltip target="load8ch" position="left">
                                  Carregar arquivo de 8 canais
                                </Tooltip>
                              </td>
                            ) : (
                              <td />
                            )}
                          </Tr>
                        ))}
                    </Tbody>
                  </Table>
                </Scroll>
              </>
            )}
            {loadingComerciais && <PendentesAvaliacaoLoader />}
            {!loadingComerciais &&
              comerciaisPendentes &&
              comerciaisPendentes.docs.length === 0 && (
                <NotFound img={PendenteAvaliacao} title="">
                  Nenhum COMERCIAL pendente de avaliação
                </NotFound>
              )}
          </Tab>
        </Tabs>
      </LeftContent>
      <RightContent>
        <Card>
          {!!playerADX && !loadingPlayer && selected && selected.midia ? (
            <Scroll height="calc(100vh - 120px)">
              <CardHeader>
                {!!selected && (
                  <div>
                    <h4>{selected.titulo}</h4>
                    <strong>- {selected.originalfilename}</strong>
                  </div>
                )}
              </CardHeader>
              <CardContent>
                <MidiaInfo>
                  <ThumbnailContainer>
                    <Image
                      onClick={() =>
                        handleThumbnailDialog(selected.midia.thumbnail_url)
                      }
                      src={selected.midia.thumbnail_url}
                      loader={<Spinner />}
                      unloader={<img src={notfound} alt="sem thumb" />}
                    />
                  </ThumbnailContainer>

                  <ul>
                    {/* <li>
                      CATEGORIA: <strong>{selected.categoria}</strong>
                    </li> */}
                    <li>
                      <p>Destino:</p>
                      <strong>
                        {destinos.length === 8
                          ? 'REDE'
                          : destinos
                              .map(
                                (d: { emissora: Emissora }) => d.emissora.sigla,
                              )
                              .join(', ')}
                      </strong>
                    </li>
                    <li>
                      <p>Loudness:</p>
                      <section>
                        {selected.midia.midiainfo8ch.loudness ? (
                          <strong>
                            {selected.midia.midiainfo8ch.loudness.value} LUFS
                          </strong>
                        ) : (
                          <strong>--</strong>
                        )}
                        <strong>/</strong>
                        {selected.midia.midiainfo.loudness ? (
                          <strong>
                            {selected.midia.midiainfo.loudness.value} LUFS
                          </strong>
                        ) : (
                          <strong>--</strong>
                        )}
                      </section>
                    </li>
                    <li>
                      <p>Status baixa:</p>
                      <div>
                        <Flag
                          name={selected.midia.statusbaixa}
                          type={selected.midia.statusbaixa}
                          disabledButton={enablePreview(selected.midia)}
                          handleAction={() =>
                            handlePlayerPreview(selected.midia.preview_url)
                          }
                          icon={<FiPlay />}
                          tooltip=" VISUALIZAR BAIXA"
                        />
                      </div>
                    </li>
                    <li>
                      <p>Pré-avaliação:</p>
                      <div>
                        <Flag
                          name={`16CH-${selected.midia.statuspreavaliacao}`}
                          type={selected.midia.statuspreavaliacao}
                          icon={<FiInfo />}
                          handleAction={() => handleMidiaInfoDialog(true)}
                          tooltip=" DADOS DA PRÉ AVALIAÇÃO"
                          disabledButton={[
                            'pendente',
                            'erro',
                            'processando',
                          ].includes(selected.midia.statuspreavaliacao)}
                        />
                        {selected.midia.categoria === Categoria.COMERCIAL && (
                          <Flag
                            name={`8CH-${selected.midia.statuspreavaliacao8ch}`}
                            type={selected.midia.statuspreavaliacao8ch}
                            icon={<FiInfo />}
                            handleAction={() => handleMidiaInfoDialog(false)}
                            tooltip=" DADOS DA PRÉ AVALIAÇÃO-8CH"
                            disabledButton={[
                              'pendente',
                              'erro',
                              'processando',
                            ].includes(selected.midia.statuspreavaliacao8ch)}
                          />
                        )}
                      </div>
                    </li>
                  </ul>
                </MidiaInfo>

                <Infos>
                  <header>
                    <h4>AVALIAÇÃO</h4>
                    <Button
                      id="info_id"
                      fill
                      color="font"
                      round
                      onClick={() => handleDialog()}
                    >
                      <FiInfo />
                    </Button>
                    <Tooltip target="info_id">Informações adicionais</Tooltip>
                  </header>
                  <div>
                    <div>
                      {selected.duracao && (
                        <p>
                          Duração indicada:{' '}
                          <strong>{selected.duracao} seg</strong>
                        </p>
                      )}
                      <p>
                        Duração selecionada:
                        <DuracaoSelecionada
                          warning={foraMargem() || !minDuration()}
                        >
                          {duracaoSelecionada} seg
                        </DuracaoSelecionada>
                      </p>
                    </div>
                  </div>
                </Infos>

                <SliderContent>
                  {/* <header>
                      <h4>AVALIAÇÃO</h4>
                    </header> */}
                  <Slider
                    color="primary"
                    value={playerADX.current}
                    max={playerADX.last_frame}
                    onChange={(value: number) => {
                      handlePlayer(Actions.SETFRAGMENT, value);
                    }}
                  />
                  <Slider
                    color="secondary"
                    markin={playerADX.markin_frame}
                    markout={playerADX.markout_frame}
                    max={playerADX.last_frame}
                  />

                  <Controls>
                    <div>
                      <Button
                        id={Actions.PLAYBETWEEN}
                        fill
                        color="flag"
                        round
                        onClick={() => handlePlayer(Actions.PLAYBETWEEN)}
                      >
                        <MdCompareArrows />
                      </Button>
                      <Tooltip target={Actions.PLAYBETWEEN}>
                        PLAY BETWEEN
                      </Tooltip>
                    </div>
                    <div>
                      <Button
                        id={Actions.GOTOMARKIN}
                        fill
                        color="flag"
                        round
                        onClick={() => handlePlayer(Actions.GOTOMARKIN)}
                      >
                        <FiChevronsDown />
                      </Button>
                      <Tooltip target={Actions.GOTOMARKIN}>
                        GO TO MARKIN (,)
                      </Tooltip>
                      <Button
                        id={Actions.MARKIN}
                        fill
                        color="flag"
                        round
                        onClick={() => handlePlayer(Actions.MARKIN)}
                      >
                        <FiChevronDown />
                      </Button>
                      <Tooltip target={Actions.MARKIN}>MARK IN (i)</Tooltip>
                      <Button
                        id={Actions.STEPBACK}
                        fill
                        color="flag"
                        round
                        onClick={() => handlePlayer(Actions.STEPBACK)}
                      >
                        <FiSkipBack />
                      </Button>
                      <Tooltip
                        target={Actions.STEPBACK}
                      >{`STEP BACK (<-)`}</Tooltip>

                      {isPlaying || isPlayingBetween ? (
                        <>
                          <Button
                            id={Actions.PLAY}
                            fill
                            color="flag"
                            round
                            onClick={() => handlePlayer(Actions.PAUSE)}
                          >
                            <FiPause />
                          </Button>
                          <Tooltip target={Actions.PLAY}>
                            PAUSE (ESPAÇO)
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <Button
                            id={Actions.PLAY}
                            fill
                            color="flag"
                            round
                            onClick={() => handlePlayer(Actions.PLAY)}
                          >
                            <FiPlay />
                          </Button>
                          <Tooltip target={Actions.PLAY}>PLAY (ESPAÇO)</Tooltip>
                        </>
                      )}

                      <Button
                        id={Actions.STEPFORWARD}
                        fill
                        color="flag"
                        round
                        onClick={() => handlePlayer(Actions.STEPFORWARD)}
                      >
                        <FiSkipForward />
                      </Button>
                      <Tooltip target={Actions.STEPFORWARD}>
                        {`STEP FORWARD (->)`}
                      </Tooltip>
                      <Button
                        id={Actions.MARKOUT}
                        fill
                        color="flag"
                        round
                        onClick={() => handlePlayer(Actions.MARKOUT)}
                      >
                        <FiChevronUp />
                      </Button>
                      <Tooltip target={Actions.MARKOUT}>MARK OUT (o)</Tooltip>
                      <Button
                        id={Actions.GOTOMARKOUT}
                        fill
                        color="flag"
                        round
                        onClick={() => handlePlayer(Actions.GOTOMARKOUT)}
                      >
                        <FiChevronsUp />
                      </Button>
                      <Tooltip target={Actions.GOTOMARKOUT}>
                        GO TO MARKOUT (.)
                      </Tooltip>
                    </div>
                  </Controls>
                </SliderContent>
                <CardActions>
                  {hasProdutora ? (
                    <div>
                      <Button
                        color="success"
                        disabled={foraMargem() || !minDuration()}
                        onClick={() =>
                          handleAvaliacaoEng(
                            Avaliacaoeng.APROVADO,
                            selected.titulo,
                          )
                        }
                      >
                        APROVAR
                      </Button>
                      <Button
                        color="warn"
                        disabled={!minDuration()}
                        onClick={() =>
                          handleAvaliacaoEng(
                            Avaliacaoeng.RESSALVA,
                            selected.titulo,
                          )
                        }
                      >
                        RESSALVA
                      </Button>
                      <Button
                        color="danger"
                        onClick={() =>
                          handleAvaliacaoEng(
                            Avaliacaoeng.REPROVADO,
                            selected.titulo,
                          )
                        }
                      >
                        REPROVAR
                      </Button>
                      <Button
                        color="secondary"
                        disabled={
                          selected.duracao === 15 || selected.duracao === 30
                        }
                        onClick={() =>
                          handleAvaliacaoEng(
                            'reprovado_patrocinio',
                            selected.titulo,
                          )
                        }
                      >
                        REPROVAR PATROCINIO
                      </Button>
                    </div>
                  ) : (
                    <Form
                      ref={formRef}
                      onSubmit={handleSubmit}
                      initialData={initialDataProdutora}
                    >
                      <p>Antes de seguir para avaliação informe a produtora:</p>
                      <SelectCreatable
                        menuPlacement="auto"
                        errorField
                        name="produtora"
                        placeholder="Selecione um produtora..."
                        options={produtoras}
                        isSearchable
                        isClearable
                        fill={false}
                        isMulti={false}
                      />

                      <Button type="submit"> SALVAR E PROSSEGUIR</Button>
                    </Form>
                  )}
                </CardActions>
              </CardContent>
            </Scroll>
          ) : (
            loadingPlayer && <PlayerLoader />
          )}
        </Card>
      </RightContent>
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
}
